import { render, staticRenderFns } from "./YA_TranslateContent1.vue?vue&type=template&id=4b0d688c&scoped=true"
import script from "./YA_TranslateContent1.vue?vue&type=script&lang=js"
export * from "./YA_TranslateContent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d688c",
  null
  
)

export default component.exports